import { Table, TablePaginationConfig } from 'antd'
import { useTranslation } from 'react-i18next'

import { Action, MethodTypeAction, TypeAction } from '@/types/apis/config/GetActionAdminChangeResponse'
import { formatHour, formatYMD } from '@/utils/date'
import { getName } from '@/utils/employee'

type Props = {
  dataSource: Action[]
  loading: boolean
  page: number
  pageSize: number
  totalItems: number
  onChange: (config: TablePaginationConfig) => void
}

const ActionAdminTable = ({ dataSource, loading, onChange, page, pageSize, totalItems }: Props) => {
  const { t } = useTranslation()

  const handleMethodType = (methodType: MethodTypeAction) => {
    switch (methodType) {
      case MethodTypeAction.POST: {
        return t('components.pages.actionAdmin.table.create')
      }
      case MethodTypeAction.PUT: {
        return t('components.pages.actionAdmin.table.update')
      }
      case MethodTypeAction.DELETE: {
        return t('components.pages.actionAdmin.table.delete')
      }
      default: {
        return t('components.pages.actionAdmin.table.import')
      }
    }
  }

  const handleTypeAction = (typeAction: TypeAction) => {
    switch (typeAction) {
      case TypeAction.ATTENDANCE: {
        return t('components.pages.actionAdmin.table.attendance')
      }
      case TypeAction.EMPLOYEE: {
        return t('components.pages.actionAdmin.table.employee')
      }
      case TypeAction.CSV_INSERT: {
        return t('components.pages.actionAdmin.table.csvInsert')
      }
      default: {
        return t('components.pages.actionAdmin.table.csvUpdate')
      }
    }
  }

  const columns = [
    {
      title: t('components.pages.actionAdmin.table.id'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('components.pages.actionAdmin.table.name'),
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: Action) => <div>{getName(record.user)}</div>,
    },
    {
      title: t('components.pages.actionAdmin.table.methodType'),
      dataIndex: 'methodType',
      key: 'methodType',
      render: (text: string, record: Action) => <div>{handleMethodType(record.methodType)}</div>,
    },
    {
      title: t('components.pages.actionAdmin.table.typeAction'),
      dataIndex: 'typeAction',
      key: 'typeAction',
      render: (text: string, record: Action) => <div>{handleTypeAction(record.type)}</div>,
    },
    {
      title: t('components.pages.actionAdmin.table.oldData'),
      dataIndex: 'oldDataJa',
      key: 'oldDataJa',
    },
    {
      title: t('components.pages.actionAdmin.table.newData'),
      dataIndex: 'newDataJa',
      key: 'newDataJa',
    },
    {
      title: t('components.pages.actionAdmin.table.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text: string, record: Action) => (
        <div>{`${formatYMD(record.createdAt)} ${formatHour(record.createdAt)}`}</div>
      ),
    },
  ]

  return (
    <Table
      style={{ whiteSpace: 'pre' }}
      rowKey="id"
      dataSource={dataSource}
      columns={columns}
      loading={loading}
      pagination={{
        pageSize,
        current: page,
        total: totalItems,
      }}
      onChange={onChange}
    />
  )
}
ActionAdminTable.displayName = 'ActionAdminTable'
export default ActionAdminTable
